import { render, staticRenderFns } from "./wjx_report.vue?vue&type=template&id=431cd832&scoped=true"
import script from "./wjx_report.vue?vue&type=script&lang=js"
export * from "./wjx_report.vue?vue&type=script&lang=js"
import style0 from "./wjx_report.vue?vue&type=style&index=0&id=431cd832&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431cd832",
  null
  
)

export default component.exports